import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = { class: "body-2 blue-grey--text" }
const _hoisted_4 = { class: "body-2 blue-grey--text" }
const _hoisted_5 = { class: "d-flex justify-center my-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            style: {"position":"absolute"},
            icon: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, { class: "text-center ml-0" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('childAdd.title')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, { ref: "search_child_form" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('childAdd.childIdLabel')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.childCode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.childCode) = $event)),
                rules: [_ctx.rules.required],
                outlined: "",
                dense: ""
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.t('childAdd.password')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                rules: [_ctx.rules.required],
                outlined: "",
                dense: "",
                type: "password"
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_btn, {
                onClick: _ctx.searchChild,
                loading: _ctx.btnLoading,
                color: "primary",
                block: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('childAdd.submit')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    })
  ]))
}